const SHORT_NOTICE_WINDOW_MS = 72 * 60 * 60 * 1000;

/** VN-04: an active vessel call whose ETA falls within the 72 h after the page was loaded. */
export const isShortNoticeCall = (eta: string | undefined | null, loadedAt: number): boolean => {
  if (!eta) return false;
  const untilArrival = Date.parse(eta) - loadedAt;
  return untilArrival >= 0 && untilArrival < SHORT_NOTICE_WINDOW_MS;
};
